import PermissionGuard from 'components/Global/PermissionGuard';
import DepartmentComponent from 'components/Settings/Masters/Department';

export const Department = () => {
	return (
		<PermissionGuard permission="Allow_Departments">
			<DepartmentComponent />
		</PermissionGuard>
	);
};
